import axios from 'axios'
import { useAuth } from '../stores/auth'

const client = axios.create({
  baseURL: '/api/v1',
  timeout: 30000,
})

client.interceptors.request.use(cfg => {
  const token = useAuth().token
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`
  }
  return cfg
})

client.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      useAuth().logout()
      if (window.location.pathname !== '/login' && window.location.pathname !== '/setup') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  },
)

export default client
